// src/components/Menu/NewburyParkMenu.tsx
import React from 'react';
import Menu from './Menu';

const NewburyParkMenu: React.FC = () => {
  return <Menu menuName="Newbury Park Menu" />;
};

export default React.memo(NewburyParkMenu);